// Input validation utilities for security

// Sanitize string input - remove potentially dangerous characters
export const sanitizeString = (str) => {
  if (typeof str !== 'string') return '';
  // Remove any characters that could be used for injection attacks
  // Allow alphanumeric, spaces, and common punctuation
  return str
    .trim()
    .replace(/[<>{}[\]"'`]/g, '') // Remove HTML/script characters
    .substring(0, 500); // Limit length to prevent DoS
};

// Validate email format
export const isValidEmail = (email) => {
  if (!email) return true; // Empty is allowed (optional field)
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email) && email.length <= 254; // RFC 5321 max length
};

// Validate phone number (UK format or international)
export const isValidPhone = (phone) => {
  if (!phone) return true; // Empty is allowed (optional field)
  // Allow digits, spaces, +, -, (, )
  const phoneRegex = /^[\d\s+()-]{7,20}$/;
  return phoneRegex.test(phone);
};

// Validate celebration/wedding code
export const isValidAccessCode = (code) => {
  if (!code) return false;
  // Allow letters, numbers, and basic punctuation
  // Length between 5 and 50 characters
  return code.length >= 5 && code.length <= 50;
};

// Validate song request
export const sanitizeSongRequest = (song) => {
  if (!song) return '';
  // Allow letters, numbers, spaces, and music-related punctuation
  return song
    .trim()
    .replace(/[<>{}[\]"'`]/g, '')
    .substring(0, 200); // Reasonable song name length
};

// Validate food choice
export const isValidFoodChoice = (choice) => {
  if (!choice) return true; // Empty is allowed
  const validChoices = ['Meatball Lasagna', 'Carbonara', 'Vegetarian - Please ask for Details'];
  return validChoices.includes(choice);
};

// Validate RSVP status
export const isValidRsvpStatus = (status) => {
  return ['attending', 'not-attending'].includes(status);
};

// Validate RSVP type
export const isValidRsvpType = (type, invitedAs) => {
  if (!type) return false;
  
  // If invited to evening only, can only select evening
  if (invitedAs === 'evening') {
    return type === 'evening';
  }
  
  // If invited all day, can choose either
  return ['allDay', 'evening'].includes(type);
};

// Validate plus one name (first or last)
export const isValidPlusOneName = (name) => {
  if (!name) return false;
  // Remove whitespace and check length
  const trimmed = name.trim();
  // Must be 1-50 characters, only letters, spaces, hyphens, apostrophes
  const nameRegex = /^[a-zA-Z\s'-]{1,50}$/;
  return trimmed.length >= 1 && nameRegex.test(trimmed);
};

// Validate plus one contact info (optional fields)
export const isValidPlusOneContact = (email, phone) => {
  // Both are optional, but if provided must be valid
  const emailValid = !email || isValidEmail(email);
  const phoneValid = !phone || isValidPhone(phone);
  return emailValid && phoneValid;
};
